import * as React from 'react'
import MUIStep from '@mui/material/Step'

const Step = (props) => <MUIStep {...props} />

export default Step
